import { db } from '../firebase';
import { collection, getDocs, query, where, orderBy, deleteDoc, doc } from 'firebase/firestore';

// Clean up duplicate certificates - keep only the very first original one
export const cleanupDuplicateCertificates = async (userId, courseId) => {
  try {
    console.log(`Cleaning up duplicates for user ${userId}, course ${courseId}`);
    
    const certificatesRef = collection(db, 'certificates');
    const existingCertQuery = query(
      certificatesRef,
      where('userId', '==', userId),
      where('courseId', '==', courseId),
      orderBy('generatedAt', 'asc') // Get oldest first to keep the original
    );
    
    const existingCerts = await getDocs(existingCertQuery);
    
    if (existingCerts.empty) {
      console.log('No certificates found');
      return null;
    }
    
    if (existingCerts.docs.length === 1) {
      console.log('Only one certificate found, no cleanup needed');
      return existingCerts.docs[0];
    }
    
    // Keep the first (oldest) certificate, delete all others
    const originalCert = existingCerts.docs[0];
    const duplicatesToDelete = existingCerts.docs.slice(1);
    
    console.log(`Found ${existingCerts.docs.length} certificates. Keeping original: ${originalCert.id}, deleting ${duplicatesToDelete.length} duplicates`);
    
    // Delete all duplicates
    for (const certDoc of duplicatesToDelete) {
      await deleteDoc(doc(db, 'certificates', certDoc.id));
      console.log(`Deleted duplicate certificate: ${certDoc.id}`);
    }
    
    console.log('Duplicate cleanup completed successfully');
    return originalCert;
    
  } catch (error) {
    console.error('Error during certificate cleanup:', error);
    throw error;
  }
};

// Check if certificate exists and return it, or null if none exists
export const getExistingCertificate = async (userId, courseId) => {
  try {
    const certificatesRef = collection(db, 'certificates');
    const existingCertQuery = query(
      certificatesRef,
      where('userId', '==', userId),
      where('courseId', '==', courseId),
      orderBy('generatedAt', 'asc')
    );
    
    const existingCerts = await getDocs(existingCertQuery);
    
    if (existingCerts.empty) {
      return null;
    }
    
    // Clean up duplicates if any exist
    if (existingCerts.docs.length > 1) {
      return await cleanupDuplicateCertificates(userId, courseId);
    }
    
    return existingCerts.docs[0];
    
  } catch (error) {
    console.error('Error getting existing certificate:', error);
    return null;
  }
};
